export * from './basicFormatter';
export * from './numberFormatter';
export * from './decimalFormatter';
export * from './percentageFormatter';
export * from './currencyFormatter';

import { basicFormatter } from './basicFormatter';
import { numberFormatter } from './numberFormatter';
import { decimalFormatter } from './decimalFormatter';
import { percentageFormatter } from './percentageFormatter';
import { currencyFormatter } from './currencyFormatter';

export const FORMATTER = {
  basic: basicFormatter,
  number: numberFormatter,
  decimal: decimalFormatter,
  percentage: percentageFormatter,
  currency: currencyFormatter,
};
